import React from 'react'

export function ResizeHandle(props: {
  size?: number
  color?: string
  strokeWidth?: number
} & React.HTMLAttributes<SVGElement> = {
  size: 16,
  color: "currentColor",
  strokeWidth: 1.5
}) {
  const { size, color, strokeWidth, ...svgProps } = props
  return (
    <svg width={size}
         height={size}
         stroke="currentColor"
         strokeWidth={strokeWidth}
         strokeLinecap="round"
         viewBox="0 0 16 16"
         fill="none"
         {...svgProps}
    >
      <line x1="6" y1="16" x2="16" y2="6" />
      <line x1="10" y1="16" x2="16" y2="10" />
      <line x1="13" y1="16" x2="16" y2="13" />
    </svg>
  )
}
